import update from "immutability-helper";
import { AutorizacionConsultaService } from "src/app/modules/autorizaciones/services/autorizacion-consulta.service";
import { async } from "rxjs/internal/scheduler/async";
import { IModalAutorizacionConsulta } from "../autorizacion.consultar.interface";
import { buildNewModalAutorizacionConsulta } from "../autorizacion.consultar.model";

export class CrudModalAutorizacionConsultaActions {
  constructor(
    private getState: () => IModalAutorizacionConsulta,
    private setState: (newState: IModalAutorizacionConsulta) => void,
    private autorizacionConsultaService: AutorizacionConsultaService
  ) {}

  getAutorizacionConsultaStart = () => {
    const state = this.getState();
    this.setState({ ...state, isLoading: true, error: null });
  };

  getAutorizacionConsultaError = (error: any) => {
    const state = this.getState();
    const newState = update(state, {
      isLoading: { $set: false },
      error: { $set: error },
    });
    this.setState(newState);
  };

  fetchSolicitudSuccess = (dataSolicitud) => {
    const state = this.getState();

    const new_state = update(state, {
      isLoading: { $set: false },
      solicitud: { $set: dataSolicitud },
    });

    this.setState(new_state);
  };

  resetModalAutorizacionConsulta = () => {
    this.setState(buildNewModalAutorizacionConsulta());
  };

  asyncFetchSolicitudById = async (idSolicitud: number) => {
    return new Promise((resolve, reject) => {
      this.getAutorizacionConsultaStart();
      this.autorizacionConsultaService
        .fetchSolicitudById(idSolicitud)
        .subscribe(
          (x) => {
            this.fetchSolicitudSuccess(x.result);
            resolve(x);
          },
          (error) => {
            this.getAutorizacionConsultaError(error);
            reject(error);
          }
        );
    });
  };
}
